import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Icon, Card } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import BicombImg from "../../assets/images/irAEs.jpg";


const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;


class irAEs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverCell: null, // { r, c }
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    };
  }


  render() {
    return (
      <div>
        <Header1></Header1>
        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                selectedKeys={[this.props.location.pathname]}   // ✅ 关键
                defaultOpenKeys={['sub1']}
                style={{
                  height: '100%',
                  borderRight: 0,
                  background: '#fafbfc'
                }}
              >
                <SubMenu
                  key="sub1"
                  title={
                    <span style={{ fontWeight: 600, fontSize: 16 }}>
                      <Icon type="medicine-box" style={{ marginRight: 8 }} />
                      irAEs Module
                    </span>
                  }
                >
                  <Menu.Item key="/irAEs" style={{ paddingLeft: 32 }}>
                    <Link to="/irAEs">
                      <span style={{ fontSize: 15 }}>Introduction</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/irAEsModel" style={{ paddingLeft: 32 }}>
                    <Link to="/irAEsModel">
                      <span style={{ fontSize: 15 }}>irAE Prediction Model</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/severeModel" style={{ paddingLeft: 32 }}>
                                      <Link to="/severeModel">
                                        <span style={{ fontSize: 15 }}>severe irAE Prediction Model</span>
                                      </Link>
                                    </Menu.Item>

                  <Menu.Item key="/PneumonitisModel" style={{ paddingLeft: 32 }}>
                    <Link to="/PneumonitisModel">
                      <span style={{ fontSize: 15 }}>Pneumonitis Model</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{ padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 300,
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <div style={{ textAlign: "center", color: "#fff" }}>
                  <br></br><br></br><br></br>
                  <span style={{ fontSize: 45, fontWeight: 'bold', color: 'rgb(0, 112, 192)' }}>
                    Immune-related adverse events prediction for
                  </span><br />
                  <span style={{ fontSize: 45, fontWeight: 'bold', color: 'rgb(0, 112, 192)' }}>
                    non-small cell lung cancer
                  </span>
                  <br></br>
                </div>
              </div>

              <div>
                <br></br>
                <br></br>
                <txt style={{ fontSize: 23, fontWeight: 'bold', paddingRight: 100 }}>
                  Introduction of the baseline model for irAEs, severe irAEs, and pneumonitis risk prediction
                </txt>
                <br></br>

                <div style={{ fontSize: 20, paddingRight: 200 }}>
                  <txt>
                    <br></br>
                    This study integrates patient-level data from a large, multicohort NSCLC population treated with ICIs, enabling robust and generalizable characterization of immune-related adverse events (irAEs).
                    <br></br><br></br>Key contributions:
                    <br></br>1. We systematically delineate the organ-specific spectrum and severity distribution of irAEs and their associations with key clinical outcomes, including survival, response, and early mortality.
                    <br></br>2. We develop and deploy an interpretable, interactive nomogram that enables individualized prediction of irAE risk using routinely available baseline clinical variables.

                    <br></br>


                    <br></br><br></br>Please cite the following study if use the information in this website:
                    <br></br><br></br>
                    <txt style={{ fontStyle: 'italic' }}>
                      Clinical architecture and risk prediction of immune-related toxicity in non-small cell lung cancer treated with immune checkpoint inhibitors: evidence from real-world data.
                    </txt>
                    <br></br><br></br>


                  </txt>
                </div>
              </div>

            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default irAEs;
